import script from "./TemplateSelectorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateSelectorModal.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateSelectorModal.vue?vue&type=style&index=0&id=5c3cd180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3cd180"]])

export default __exports__